<template>
    <el-button :type="type" v-bind="$attrs" v-on="$listeners" icon="fa fa-fw fa-times-circle-o">
        重置
    </el-button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'default'
        }
    },
    methods: {
    }
}
</script>
